if (document.body.classList.contains("front-page")) {
  const heroActiveClass = "hero__content--active";
  const truckActiveClass = "hero__truck--active";

  const allHeroContents = document.querySelectorAll(".hero__content");
  const allHeroTrucks = document.querySelectorAll(".hero__truck");

  document.querySelectorAll(".pill-tabs").forEach(el => {
    const pillContainer = el as HTMLElement;

    let currentPillId = -1;

    const pills = el.querySelectorAll<HTMLButtonElement>(".pill__tab");
    const pillCount = pills.length;
    pillContainer.style.setProperty("--pill-count", pillCount.toString());

    el.addEventListener("click", (e) => {
      e.preventDefault();

      const clickedPillTab = e.target as HTMLButtonElement;

      const pillId = [...pills].indexOf(clickedPillTab);

      if (pillId === -1 || currentPillId === pillId) return;

      // toggle the correct hero content section
      document
        .querySelector(`.${heroActiveClass}`)
        ?.classList.remove(heroActiveClass);
      allHeroContents[pillId].classList.add(heroActiveClass);

      // toggle the correct truck
      document
        .querySelector(`.${truckActiveClass}`)
        ?.classList.remove(truckActiveClass);
      allHeroTrucks[pillId].classList.add(truckActiveClass);

      // toggle the correct pill tab
      document.querySelector(".pill__tab--active")?.classList.remove("pill__tab--active");
      clickedPillTab.classList.add("pill__tab--active");

      pillContainer.style.setProperty("--pill-current", pillId.toString());
      pillContainer.style.setProperty("--pill-current-bg", clickedPillTab.style.getPropertyValue("--current-bg-colour"));

      currentPillId = pillId;
    });

    // auto click the first pill
    pills[0].click();
  });
}
